import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pimg1 from '../../images/cloudfare.svg'
import pimg2 from '../../images/coin.svg'
import pimg3 from '../../images/python.svg'
import pimg4 from '../../images/xrp.svg'

const partners = [
    {
        pImg: pimg1,
        link: 'https://www.cloudflare.com/'
    },
    {
        pImg: pimg3,
        link: 'https://www.python.org/'
    },
    {
        pImg: pimg4,
        link: 'https://xrpl.org/'
    },
    {
        pImg: pimg2,
        link: 'https://cointelegraph.com/'
    },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1700,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 340,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {

    return (
        <section className="partner_section" style={{ paddingTop: '50px' }}>
            <div className="container-fluid">
                <div className="ico_heading_block text-center">
                    <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration="600">
                        Partners and Integrations
                    </h2>
                </div>
                <div className="partner_logo_carousel z-2 position-relative" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
                    <Slider {...settings}>
                        {partners.map((partner, pitem) => (
                            <div className="ico_partner_logo" key={pitem}>
                                <a className="logo_wrap" href={partner.link} target="_blank" rel="noreferrer">
                                <img src={partner.pImg} alt="Partner Logo"/>
                                    <span className="dot_1"></span>
                                    <span className="dot_2"></span>
                                    <span className="dot_3"></span>
                                    <span className="dot_4"></span>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
}

export default PartnerSection;